import { FontStyle, italic, normal } from "@cloudinary/transformation-builder-sdk/qualifiers/fontStyle";
export { FontStyle, italic, normal };
